import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Checkbox, Form, Input, Modal } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setLoading } from "../../redux/store/common/commonDuck";

const GroupBuyingModal = ({ alertShow, setAlertShow }) => {
	const dispatch = useDispatch();

	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [alertValue, setAlertValue] = useState({
		name: "",
		phone: "",
		phoneValid: "",
		agreement: false,
	});

	const handleBuyingAlert = async () => {
		if (
			!alertValue?.name.length > 0 ||
			!alertValue.phone.length > 0 ||
			!alertValue.phoneValid.length > 0 ||
			!alertValue?.agreement
		) {
			alert(
				"이름과 휴대폰 번호, 마케팅 정보 수신 동의를 정확하게 입력해주세요."
			);
		} else {
			if (alertValue.phone.length !== 11) {
				alert("휴대폰 번호를 정확하게 입력해주세요.");
			} else {
				if (alertValue.phone !== alertValue.phoneValid) {
					alert("휴대폰 번호가 일치하지 않습니다.");
				} else {
					setIsLoading(true);
					const param = {
						cooperate_id: null,
						influencer_id: reduxChannel.user_id,
						name: alertValue.name,
						phone: alertValue.phone,
					};
					const res = await partnersApi.createGroupBuyingAlert(param);
					if (res.code === 200) {
						alert("정상적으로 등록되었습니다!");
					} else {
						alert("이미 등록된 번호입니다.");
					}
					setIsLoading(false);
					setAlertShow(false);
				}
			}
		}
	};

	return (
		<Modal
			title={`${
				reduxChannel?.user_id !== 7 ? "이벤트" : "공동구매"
			} 놓치지 않도록\n알림을 드릴게요!`}
			wrapClassName="group-buying-modal"
			open={alertShow}
			centered={true}
			onCancel={() => setAlertShow(!alertShow)}
			width="50%"
			cancelText={<span>취소</span>}
			okText={<span>조회</span>}
			footer={null}
			// onOk={handleMyComment}
			// confirmLoading={isLoading}
		>
			<Form layout={`vertical`}>
				<Form.Item label="이름" labelAlign="left" colon={false} required>
					<Input
						type={`text`}
						placeholder={`성함을 입력해주세요`}
						required
						value={alertValue.name}
						onChange={(e) => {
							setAlertValue({
								...alertValue,
								name: e.target.value,
							});
						}}
						// style={!findMineValid.phoneCenter ? {borderColor: "#fe2b4b"} : {}}
					/>
				</Form.Item>
				<Form.Item label="휴대폰 번호" labelAlign="left" colon={false} required>
					<Input
						type={`text`}
						placeholder={`'-'빼고 입력해주세요`}
						required
						value={alertValue.phone}
						onChange={(e) => {
							setAlertValue({
								...alertValue,
								phone: e.target.value.replace(/[^0-9]/g, ""),
							});
						}}
						pattern="\d*"
						// style={!findMineValid.password ? {borderColor: "#fe2b4b"} : {}}
					/>
				</Form.Item>
				<Form.Item
					label="휴대폰 번호 확인"
					labelAlign="left"
					colon={false}
					required
				>
					<Input
						type={`password`}
						placeholder={`휴대폰 번호를 한번 더 입력해주세요`}
						required
						value={alertValue.phoneValid}
						onChange={(e) => {
							setAlertValue({
								...alertValue,
								phoneValid: e.target.value.replace(/[^0-9]/g, ""),
							});
						}}
						pattern="\d*"
						// style={!findMineValid.password ? {borderColor: "#fe2b4b"} : {}}
					/>
				</Form.Item>
				<Checkbox
					className={`group-buying-checkbox`}
					onChange={(e) => {
						setAlertValue({
							...alertValue,
							agreement: e.target.checked,
						});
					}}
					checked={alertValue.agreement}
				>
					<p>마케팅 정보 수신 동의</p>
					<p style={{ color: "#adb5bd" }}>
						{reduxChannel?.user_id !== 7 ? "이벤트" : "공동구매"} 관련 소식에
						대한 수신에 동의합니다.
					</p>
				</Checkbox>
				<Button
					className={`group-buying-alert`}
					onClick={handleBuyingAlert}
					loading={isLoading}
				>
					<img
						src={`/assets/images/channel/alert-white.png`}
						alt={`${
							reduxChannel?.user_id !== 7 ? "이벤트" : "공동구매"
						} 알림 받기`}
						className={`group-buying-alert-icon`}
						style={{
							height: "auto",
							width: "1.2em",
						}}
					/>
					{reduxChannel?.user_id !== 7 ? "이벤트" : "공동구매"} 알림받기
				</Button>
			</Form>
		</Modal>
	);
};
export default GroupBuyingModal;
